import React, { lazy } from "react";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import Spin from "core/ui-kit/spin";

import ROUTES from "core/constants/routes/routes";

import withSuspenseHoc from "core/HOCs/withSuspense";
import withAnonymousHoc from "core/HOCs/withAnonymous";

const RegisterEmbeddedContainer = withSuspenseHoc(lazy(() => import("./registerEmbeddedContainer")), <Spin />);

const UnAuthorizedWrapper = withAnonymousHoc(RegisterEmbeddedContainer);

const RegisterEmbeddedPageRoute = {
    path: ROUTES.REGISTER_EMBEDDED,
    element: (
        <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.SYSTEM_CAPTCHA_KEY}>
            <UnAuthorizedWrapper />
        </GoogleReCaptchaProvider>
    )
}

export default RegisterEmbeddedPageRoute;
